export const transformCsvData = data => {
    const result = [];
    let lastDateInHistory = null;

    data.forEach(row => {
        let lastDateInHistoryKw = null;
        const { keyword, url } = row;
        const dateHeaders = row.DateHeaders;
        const dates = row.Dates;
        const urlData = row.UrlData || [];

        if (!keyword) return;

        let existingKeyword = result.find(item => item.keyword === keyword);

        if (!existingKeyword) {
            const lastRank = dates[dates.length - 1];
            existingKeyword = {
                keyword,
                history: [],
                source: 'se-ranking',
                last: { rank: lastRank === '-' || lastRank === 'No data' || !lastRank ? null : parseInt(lastRank, 10) },
            };
            result.push(existingKeyword);
        }

        dates.forEach((rank, index) => {
            const date = dateHeaders[index];
            const rankingUrl = urlData[index] || url;

            if (!date) return;

            // save the oldest date in history
            if (!lastDateInHistory || date < lastDateInHistory) {
                lastDateInHistory = date;
            }

            if (!lastDateInHistoryKw || date < lastDateInHistoryKw) {
                lastDateInHistoryKw = date;
            }

            if (rank && rank !== '-' && rank !== '0' && rank !== 'No data' && rank !== '' && rank !== 'No data in GSC') {
                const parsedRank = parseInt(rank, 10);
                if (!isNaN(parsedRank) && parsedRank > 0) {
                    const dateEntry = {
                        [date]: {
                            main: [{ r: parsedRank, u: rankingUrl }],
                        },
                    };
                    existingKeyword.history.push(dateEntry);
                    existingKeyword.lastDateInHistoryKw = lastDateInHistoryKw;
                }
            }
        });
    });

    return { result, lastDateInHistory };
};

export const convertKwToObj = (kw: string, source: string) => ({ keyword: kw, history: [], source });
